<script async setup lang="ts">
import 'vue3-carousel/dist/carousel.css';

import { onMounted, ref, watch } from 'vue';

import { useEventStore } from '@/stores/events.store';
import { EventEntity } from '@/entities/interfaces/events';
import EventCarousel from '@/components/custom/sections/EventCarousel.vue';

const eventStore = useEventStore();

const event = eventStore.getEvent;
const events = eventStore.getEventsTimeline;

const nextEvents = ref();
const prevEvents = ref();

const updateEvents = () => {
  nextEvents.value = events.value?.nextEvents.filter(
    (item: EventEntity) => item.id != event.value?.id
  );
  prevEvents.value = events.value?.prevEvents.filter(
    (item: EventEntity) => item.id != event.value?.id
  );
};

onMounted(() => {
  updateEvents();
});

watch(event, () => {
  updateEvents();
});
</script>
<template>
  <div class="next-events events" v-if="events && nextEvents?.length > 0">
    <h1 class="centered">Предстоящие мероприятия</h1>

    <EventCarousel :events="nextEvents" />
  </div>

  <div class="prev-events events" v-if="events && prevEvents?.length > 0">
    <h1 class="centered">Прошедшие мероприятия</h1>

    <EventCarousel :events="prevEvents" />
  </div>
</template>

<style scoped lang="scss">
.events {
  padding: 60px 0;
}

@media screen and (max-width: 1024px) {
  .prev-events {
    padding: 0 0 120px;
  }
}
</style>
